import { render, staticRenderFns } from "./ReportListPage.vue?vue&type=template&id=d6483328&scoped=true"
import script from "./ReportListPage.vue?vue&type=script&lang=js"
export * from "./ReportListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6483328",
  null
  
)

export default component.exports